import {
  DateValidationObject,
  DynamicFieldSchema,
} from '../../../application/domain/entities/Section2';
import { DocumentFieldDto } from '../dto/res/DocumentSchemaResponseDto';

export function mapDocumentSchemaDtoToEntity(dto: DocumentFieldDto[]): DynamicFieldSchema[] {
  // The API sends an order; honour it rather than trusting array order.
  return [...dto]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((field) => mapFieldDtoToEntity(field));
}

function parseDateValidation(rule: any): any {
  if (!rule) return undefined;

  const value = rule.value;
  if (typeof value === 'string') {
    try {
      return {
        ...rule,
        value: JSON.parse(value) as DateValidationObject,
      };
    } catch (e) {
      console.error('Failed to parse date validation value:', value, e);
      return rule;
    }
  }
  return rule;
}

function mapFieldDtoToEntity(dto: DocumentFieldDto): DynamicFieldSchema {
  return {
    id: dto.id,
    name: dto.name,
    label: dto.label,
    type: dto.type,
    placeholder: dto.placeholder,
    helperText: dto.helperText,
    options: dto.options,
    visibleWhen: dto.visibleWhen,
    readOnly: dto.readOnly,
    defaultValue: dto.defaultValue,
    derivedFrom: dto.derivedFrom,
    masked: dto.masked,
    uploadSlot: dto.uploadSlot,
    fixedBy: dto.fixedBy,
    calculated: dto.calculated,
    validation: dto.validation
      ? {
          required: dto.validation.required,
          min_length: dto.validation.min_length,
          max_length: dto.validation.max_length,
          min_date: parseDateValidation(dto.validation.min_date),
          max_date: parseDateValidation(dto.validation.max_date),
          pattern: dto.validation.pattern,
          max_size: dto.validation.max_size,
          allowed_types: dto.validation.allowed_types,
          equals: dto.validation.equals,
          not_before: dto.validation.not_before,
        }
      : undefined,
  };
}
